import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import type { EmployeeCommunicationFormatted } from '@/features/beneficiaries/beneficiaries.types';
import { formatDateTime } from '@/utils/date.utils';

const columnHelper = createColumnHelper<EmployeeCommunicationFormatted>();

export const employeeCommunicationsColumns = [
  columnHelper.accessor((row) => row.dateTime, {
    id: 'dateTime',
    header: 'Date',
    cell: (info) => formatDateTime(info.getValue()),
    meta: { filterType: 'numeric' },
  }),
  columnHelper.accessor('description', {
    header: 'Objet',
    meta: { filterType: 'text' },
  }),
] as ColumnDef<EmployeeCommunicationFormatted>[];
